import React from "react";
import {
  confirmEmailCode,
  restartEmailLogin,
  selectAwaitingCode,
  selectLoginErrors,
  selectPendingEmail,
  startEmailLogin,
} from "./authSlice";
import {useDispatch, useSelector} from 'react-redux';
import {FormProvider, useForm} from "react-hook-form";
import {ErrorMessage} from '@hookform/error-message';
import {handleServerSubmit, useServerErrors} from "../../form/formErrors";
import {Field} from "../../form/Field";

export function Login() {
  const dispatch = useDispatch()
  const formMethods = useForm()
  const {errors, setError} = formMethods
  const apiErrors = useSelector(selectLoginErrors)
  const awaitingCode = useSelector(selectAwaitingCode)
  const pendingEmail = useSelector(selectPendingEmail)
  useServerErrors(setError, apiErrors)

  const onSubmit = values => {
    if (awaitingCode)
      dispatch(confirmEmailCode(values.code))
    else
      dispatch(startEmailLogin(values.email))
  }

  return (
      <FormProvider {...formMethods}>
        <form className={"Login"} onSubmit={handleServerSubmit(formMethods, onSubmit)}>
          <h2>{awaitingCode ? 'Check your email' : 'Welcome to Swurf'}</h2>
          <div className={"authNav"}>
            {awaitingCode
                ? `Enter the six-digit code sent to ${pendingEmail}.`
                : 'Enter your email to log in or create your host account.'}
          </div>
          <ErrorMessage className="error-message" name="non_field_errors" as="div" errors={errors}/>
          {awaitingCode ? (
              <Field
                  key="login-code"
                  label="Login code"
                  name={"code"}
                  autocomplete={"one-time-code"}
                  required={true}
                  registerOptions={{
                    pattern: {
                      value: /^\d{6}$/,
                      message: 'Enter the six-digit code from your email',
                    },
                  }}
                  inputProps={{inputMode: 'numeric', maxLength: 6, autoFocus: true}}
              />
          ) : (
              <Field
                  key="email"
                  type={"email"}
                  label="Email"
                  name={"email"}
                  required={true}
              />
          )}
          <div className={"field"}>
            <button>{awaitingCode ? 'Confirm code' : 'Email me a code'}</button>
          </div>
          {awaitingCode && (
              <div className={"authActions"}>
                <button type="button" onClick={() => dispatch(startEmailLogin(pendingEmail))}>
                  Send a new code
                </button>
                <button type="button" onClick={() => dispatch(restartEmailLogin())}>
                  Use a different email
                </button>
              </div>
          )}
        </form>
      </FormProvider>
  );
}
